class PushCartRecommendations extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  async render() {
    const url = this.dataset.url;
    if (!url) {
      console.error('No URL provided for recommendations.');
      return;
    }

    try {
      const response = await fetch(url);
      const text = await response.text();

      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('push-cart-recommendations');

      if (recommendations) {
        this.innerHTML = recommendations.innerHTML;
        this.initializeCarousel();
      }

    } catch (error) {
      console.error('Error fetching recommendations:', error);
      this.innerHTML = '<p>Error loading recommendations.</p>';
    }
  }

  initializeCarousel() {
    const slidesElement = this.querySelector('[data-push-cart-carousel-el="slides"]');
    if (!slidesElement) {
      console.error('No slides element found for carousel.');
      return;
    }

    const next = this.querySelector('[data-push-cart-carousel-el="next"]')
    const prev = this.querySelector('[data-push-cart-carousel-el="prev"]')

    new KeenSlider(slidesElement, {
      selector: '[data-push-cart-carousel-el="slide"]',
      rubberband: false,
      loop: false,
      mode: 'snap',
      slides: {
        perView: 1.1,
        spacing: 20,
      }
    },
    [
      window.BAO.Carousel.plugins.useInitialised(),
      window.BAO.Carousel.plugins.useArrows({
        next: next,
        previous: prev,
      }),
    ]);
  }
}

customElements.define('push-cart-recommendations', PushCartRecommendations);
